export default "__VITE_ASSET__9b515ceb__"